import {
  Notification,
  NotificationStatus,
} from '@/fsd/entities/notifications/model/types/types';
import { NewspaperIcon } from '@/fsd/shared/ui/icons';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import { formatNotificationDate } from '../../model/helpers/formatNotificationDate';
import { useNotificationItem } from '../../model/hooks/useNotificationItem';
import NotificationItemsContent from '../NotificationItemsContent/NotificationItemsContent';
import styles from './NotificationItem.module.scss';

interface IProps {
  item: Notification;
  status: NotificationStatus;
}

const NotificationItem = observer(({ item, status }: IProps) => {
  const { expanded, setExpanded } = useNotificationItem();

  return (
    <div
      className={cx(
        styles.container,
        expanded && styles.expanded,
        styles[`notification-status__${item.status}`]
      )}
    >
      <div className={styles.date}>{item.datetime}</div>
      <div className={styles.body}>
        <div className={styles.iconWrapper}>
          <div className={styles.icon}>
            <NewspaperIcon />
          </div>
        </div>
        <div className={cx(styles.content)}>
          <NotificationItemsContent
            expanded={expanded}
            item={item}
            setExpanded={setExpanded}
            status={status}
          />

          {/* <NotificationItemsButtons
            expanded={expanded}
            item={item}
            loadingAcceptOperation={loadingAcceptOperation}
            loadingRejectOperation={loadingRejectOperation}
            onAcceptClick={onAcceptClick}
            onRejectClick={onRejectClick}
          /> */}
        </div>
      </div>
    </div>
  );
});

export default NotificationItem;
